import * as React from "react";
import {Option} from "ts-option";
import Lead from "../../../../model/lead/Lead";
import TrackingData from "../../../../model/lead/TrackingData";
import {editLead} from "../../../../store/action/lead/lead";
import {Dispatch} from "redux";
import Toast from "../../../helper/Toast";
import {connect} from "react-redux";
import {MarketingAndTracking} from "./MarketingAndTracking";

interface IComponentProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface IDispatchProps {
	/**
	 * Edit lead action.
	 * @param {Lead} lead
	 */
	editLead: (lead: Lead) => void;
}

type Props = IComponentProps & IDispatchProps

class LeadMarketingAndTracking extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<MarketingAndTracking tracking={this.props.lead.flatMap(l => l.data.tracking)} onChange={this.onChange}/>
		);
	}

	onChange(tracking: Option<TrackingData>) {
		this.props.lead.map(l => {
			const updatedLead = l.copy({data: l.data.copy({tracking})});
			this.props.editLead(updatedLead)
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editLead: (lead: Lead) => dispatch(
			editLead(
				lead,
				() => Toast.success("Lead inbound Marketing & Tracking updated", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

export default connect(null, mapDispatchToProps)(LeadMarketingAndTracking)